import ImageEditor from '@intercom/embercom-composer/components/image-editor';
export default ImageEditor;
